import { useState, useEffect } from "react";
import { WhatsappLogo } from "@phosphor-icons/react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from "../ui/dialog";
import { waLink } from "../../data/site";

const field =
    "w-full rounded-md border border-border bg-surface-2 px-4 py-2.5 text-sm text-ink placeholder:text-ink-soft/60 outline-none focus:border-accent transition-colors duration-200";

export const PurchaseModal = ({ product, open, onClose }) => {
    const [form, setForm] = useState({ nama: "", qty: 1, kawasan: "", nota: "" });

    useEffect(() => {
        if (open) setForm({ nama: "", qty: 1, kawasan: "", nota: "" });
    }, [open, product]);

    if (!product) return null;

    const valid = form.nama.trim() && form.kawasan.trim();

    const submit = () => {
        if (!valid) return;
        const qty = String(form.qty).trim() && Number(form.qty) > 0 ? form.qty : 1;
        const msg =
            `Hai ASTANA KUCING'S! Saya ingin menempah:\n\n` +
            `• Model: ${product.model} (${product.label})\n` +
            `• Harga: ${product.price}\n` +
            `• Bilangan: ${qty} unit\n\n` +
            `Nama: ${form.nama}\n` +
            `Kawasan/Negeri: ${form.kawasan}\n` +
            `Nota: ${form.nota.trim() || "-"}\n\n` +
            `Saya faham deposit 50% masa order & baki semasa penghantaran.`;
        window.open(waLink(msg), "_blank", "noopener,noreferrer");
        onClose();
    };

    const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    return (
        <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
            <DialogContent
                data-testid="purchase-modal"
                className="bg-surface border-border text-ink max-w-md p-0 overflow-hidden gap-0"
            >
                <div className="flex gap-4 p-6 border-b border-border">
                    <img
                        src={product.image}
                        alt={product.model}
                        className="h-20 w-20 object-cover rounded-md border border-border bg-white shrink-0"
                    />
                    <DialogHeader className="text-left space-y-1">
                        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-accent">
                            {product.model}
                        </span>
                        <DialogTitle className="font-display text-2xl text-ink">
                            {product.price}
                        </DialogTitle>
                        <DialogDescription className="text-ink-soft">
                            {product.label}
                        </DialogDescription>
                    </DialogHeader>
                </div>

                <div className="p-6 space-y-4">
                    <div>
                        <label className="block mb-1.5 text-xs uppercase tracking-[0.15em] text-ink-soft">
                            Nama penuh
                        </label>
                        <input
                            data-testid="purchase-nama"
                            className={field}
                            placeholder="Cth: Nur Aina"
                            value={form.nama}
                            onChange={set("nama")}
                        />
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block mb-1.5 text-xs uppercase tracking-[0.15em] text-ink-soft">
                                Bilangan unit
                            </label>
                            <input
                                data-testid="purchase-qty"
                                type="number"
                                min="1"
                                className={field}
                                value={form.qty}
                                onChange={set("qty")}
                            />
                        </div>
                        <div>
                            <label className="block mb-1.5 text-xs uppercase tracking-[0.15em] text-ink-soft">
                                Kawasan / Negeri
                            </label>
                            <input
                                data-testid="purchase-kawasan"
                                className={field}
                                placeholder="Cth: Shah Alam"
                                value={form.kawasan}
                                onChange={set("kawasan")}
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block mb-1.5 text-xs uppercase tracking-[0.15em] text-ink-soft">
                            Catatan (pilihan)
                        </label>
                        <textarea
                            data-testid="purchase-nota"
                            rows={2}
                            className={field + " resize-none"}
                            placeholder="Warna, ukuran khas, dll."
                            value={form.nota}
                            onChange={set("nota")}
                        />
                    </div>

                    <div className="rounded-md bg-surface-2 border border-border px-4 py-3 text-xs text-ink-soft leading-relaxed">
                        Deposit <span className="text-ink font-semibold">50%</span> semasa
                        tempahan, baki dijelaskan semasa penghantaran.
                    </div>

                    <button
                        data-testid="purchase-submit"
                        onClick={submit}
                        disabled={!valid}
                        className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-accent px-6 py-3.5 text-sm font-semibold text-white hover:bg-accent-hover transition-colors duration-300 disabled:opacity-40 disabled:cursor-not-allowed"
                    >
                        <WhatsappLogo size={18} weight="fill" />
                        Hantar Tempahan ke WhatsApp
                    </button>
                </div>
            </DialogContent>
        </Dialog>
    );
};
